module.exports = __webpack_public_path__ + "static/media/mock-homeselect1.13804c9f.png";